import React from 'react';
import DetailCard from './DetailCard';
import styles from './DetailCard.css';
import ListItem from '../ListItem';

function DetailRequirementsFastLoan() {
  return (
    <div className={styles['detail-requirements']}>
      <DetailCard title="Persyaratan Pengajuan Fast Loan" border="blue">
        <ListItem>Merchant Moka minimal 8 bulan</ListItem>
        <ListItem>Penjualan per bulan minimal Rp7 juta</ListItem>
        <ListItem>Pengajuan dilakukan oleh pemilik bisnis</ListItem>
      </DetailCard>
    </div>
  );
}

export default DetailRequirementsFastLoan;
